module.exports = __webpack_public_path__ + "static/media/check-red.3bfbf252.svg";